<template>
  <div class="wrapper">
    <div class="titleCertificates">
      {{WarnInfoList.VoucherType}}
    </div>
    <div class="LookImg" v-if="WarnInfoList.VoucherType == '营业执照'">
      <CommonuploadEnclosure ref="UploadEnclisureRef" :typeUpload="3" title=""  :BLPhotoURL="WarnInfoData.BLPhotoURL"></CommonuploadEnclosure>
    </div>
      <div class="LookImg" v-if="WarnInfoList.VoucherType == '第二类医疗器械备案凭证'">
      <CommonuploadEnclosure ref="UploadEnclisureRef" :typeUpload="3" title=""  :BLPhotoURL="WarnInfoData.BRPhotoURL"></CommonuploadEnclosure>
    </div>
      <div class="LookImg" v-if="WarnInfoList.VoucherType == '医疗器械经营许可证'">
      <CommonuploadEnclosure ref="UploadEnclisureRef" :typeUpload="3" title=""  :BLPhotoURL="WarnInfoData.BusPhotoURL"></CommonuploadEnclosure>
    </div>
    <div class="reject">
      <img src="../../../../../../../assets/channel/reject.png" alt="" style="width: 24px;height:24px;vertical-align: middle;margin-right: 10px;">
      <span v-html="$options.filters.filters2(WarnInfoList.StringMessage)">
      </span>
    </div>
  </div>
</template>

<script>
import CommonuploadEnclosure from '../../../../../../../components/common-upload-Enclosure.vue'
export default {
  components: {CommonuploadEnclosure},
  props: {
    WarnInfoList: {
      type: Object
    },
    WarnInfoData: {
      type: undefined
    }
  },
   filters: {
    filters2(arg) {
      let args = null
      if (arg) {
        args = arg.replace('<span style=\"\"color: #E71D43\"\">', '<span style="color: #E71D43">')
      }
      return args;
    }
  },
  data() {
    return {

    }
  },
  created() { },
  mounted() { },
  activated() { },
  updated() { },
  methods: {},
  computed: {},
  watch: {},
}
</script>
<style scoped lang='less'>
@import url(../../style/index.less);
</style>